import { createTheme, IconButton, makeStyles, Modal } from "@material-ui/core";
import React, { useEffect } from "react";
import { GeneralTable } from "../GeneralComponents/GeneralTable";
import moment from "moment";
import { Button, CardBody, Col, Container, Row } from "reactstrap";
import history from "../../history";
import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import CloseIcon from "mdi-react/CloseIcon";
import { useModalAlertaAprobar, useModalAlert } from "../GeneralComponents";
const defaultMaterialTheme = createTheme({});

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    display: "flex",
    margin: theme.spacing(1),
  },
  centeredCell: {
    display: "flex",
    alignItems: "center", 
    whiteSpace: "pre-wrap", 
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
}));

export function ChangeHistory(props) {
  const { location } = props  
  const classes = useStyles();
  const [version, setVersion] = React.useState(null);
  const [versiones, setVersiones] = React.useState([]);
  const [showPdf, setShowPdf] = React.useState(false);
  const { showDecisionModal } = useModalAlertaAprobar();
  const { showModalAlert } = useModalAlert();
  const [documentoSeleccionado, setDocumentoSeleccionado] =
    React.useState(null);

  useEffect(() => {
    loadVersiones();
  }, []);

  const loadVersiones = async () => {
    const id_gd_documentos = location.state.documento?.id_gd_documentos;        
    await fetch(process.env.REACT_APP_PUBLIC_URL + `version/listar?id_gd_documentos=${id_gd_documentos}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const versionesConId = data.map((version) => ({
          ...version,
          id: version.id_gd_documentos_historial,
        }));
        setVersiones(versionesConId);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleDelete = async () => {
    setIsdeleted(false);
    loadList();
    onInactivate(data);
  };

  const columns = [
    {
      field: "version",
      headerName: "VERSIÓN",
      type: "text",
      flex: 0.6,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "fecha_creacion",
      headerName: "FECHA CREACIÓN",
      type: "date",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "descripcion_cambio",
      headerName: "DESCRIPCIÓN DEL CAMBIO",
      type: "string",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: '100%' }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "item_pagina",
      headerName: "ITEM Y/O PÁGINA",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "estado_documento",
      headerName: "ESTADO DOC",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "motivo",
      headerName: "MOTIVO",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: '100%' }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "estado_documento",
      headerName: "ESTADO DOCUMENTO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
    },
  ];

  async function handleSaveNewSerie() {
    console.log("Datos a guardar para Nueva Serie:");
  }

  const onActivate = (row) => {};
  const onInactivate = (row) => {};

  const handleApprove = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_documentos_historial: row.id_gd_documentos_historial,
        id_usuario: usuario.id_usuario,
      };

      await fetch(process.env.REACT_APP_PUBLIC_URL + "version/aprobar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });

      loadVersiones();
      showModalAlert("success", "Se aprobo correctamente la version");
    } catch (error) {
      showModalAlert("danger", "Error al aprobar la version");
    }
  };
  const handleReject = async (motivo, row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_documentos_historial: row.id_gd_documentos_historial,
        id_usuario: usuario.id_usuario,
        motivo,
      };

      await fetch(process.env.REACT_APP_PUBLIC_URL + "version/rechazar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadVersiones();
      showModalAlert("success", "Se rechazo la version");
    } catch (error) {
      showModalAlert("danger", "Error al rechazar la version");
    }
  };

  const openFlow = (row) => {
    const onApproveCallback = () => handleApprove(row);
    const onRejectCallback = (motivo) => handleReject(motivo, row);
    showDecisionModal(
      "warning",
      "Confirmación de Acción",
      onApproveCallback,
      onRejectCallback
    );
  };

  const actionsList = [
    {
      title: "Aprobar/Rechazar",
      ariaLabel: "history-changes",
      icon: <ThumbUpAltIcon />,
      onClick: (row) => {
        openFlow(row);
      },
      //show: (row) => !!row, // Puedes controlar visibilidad
    },
    {
      title: "Ver documento",
      ariaLabel: "view-document",
      icon: <PictureAsPdfIcon />,
      onClick: (row) => {
        setDocumentoSeleccionado(row);
        setShowPdf(true);
      },
    },
  ];

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <div className="title-general-section-icon-arrow-back">
            <h3>Gestión de documentos</h3>
          </div>
        </Col>
        <Col md={12}>
          <Button
            className="btn btn-sm"
            color="primary"
            onClick={() => {
              history.push({
                pathname:
                  process.env.PUBLIC_URL + "/document-management/documentation",
              });
            }}
          >
            Regresar al documento
          </Button>
        </Col>
      </Row>
      <Row>
        <CardBody style={{ padding: 30 }}>
          <GeneralTable
            title=""
            titleAlert="Historial de versiones"
            columns={columns}
            rows={versiones}
            initialFormData={{
              codigo: "",
              descripcion: "",
              fecha_creacion: moment(),
            }}
            onSaveModal={handleSaveNewSerie}
            actionsList={actionsList}
            onActivate={onActivate}
            onInactivate={onInactivate}
            enableActivate={false}
            enableUpdate={false}
            enableDocumentarytype={false}
            enableView={false}
          />
        </CardBody>
      </Row>
      {showPdf ? (
        <Modal
          open={showPdf}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <IconButton
              style={{ float: "right" }}
              onClick={() => {
                setShowPdf(false);
              }}
            >
              <CloseIcon />
            </IconButton>
            <iframe
              id="pdfV"
              width="1000"
              height="700"
              src={
                process.env.REACT_APP_PUBLIC_URL +
                "doc-version/ver/" +
                documentoSeleccionado.id_gd_documentos_historial +
                "/" +
                sessionStorage.getItem("token")
              }
            ></iframe>
          </div>
        </Modal>
      ) : null}
    </Container>
  );
}
